/**
 * Utility for merging CSS class names
 * Simple implementation - can be replaced with clsx or classnames if needed
 * 
 * @param {...string} classes - Class names to merge
 * @returns {string} Merged class names
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Conditional class utility
 * 
 * @param {string} baseClasses - Always applied classes
 * @param {Object} conditionalClasses - Object with condition: className pairs
 * @returns {string} Final class string
 */
export function conditional(baseClasses, conditionalClasses = {}) {
  const conditionals = Object.entries(conditionalClasses)
    .filter(([condition]) => condition)
    .map(([, className]) => className);
    
  return cn(baseClasses, ...conditionals);
}